import React from 'react'
import {removeZeros, round} from '../../../utils/misc'
export default class PurchaseBasicRate extends React.Component {
  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

handleChange(e) {
  let item = this.props.item, key= e.target.name, value=round(e.target.value, 6)


  item[key]= parseFloat(value)
  this.props.onChangeCallback(item)
}

  render(){

    let val = this.props.item.purchase_basic_rate
    if(val > 0) {
      val = removeZeros(val)
    }

    return <input type="number" step=".01" name="purchase_basic_rate" className="form-control input-sm" onChange={this.handleChange} value={val}  />
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/purchasebasicrate.js